import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import mixpanel from "mixpanel-browser";
import { isChrome } from "react-device-detect";
import Profile from "../Icons/Profile.svg";
import Chrome from "../Icons/Chrome.svg";
import Support from "../Icons/Support.svg";
import Feature from "../Icons/Feature.svg";
import AddArticle from "./AddArticle";
import Search from "../Icons/Search.svg";
import Reset from "../Icons/Reset.svg";
import PaidIcon from '@mui/icons-material/Paid';
// import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
// import AccountCircleIcon from "@material-ui/icons/AccountCircle";
// import RssFeedIcon from "@material-ui/icons/RssFeed";
import {
  PowerSettingsNew as PowerSettingsNewIcon,
  AccountCircle as AccountCircleIcon,
  RssFeed as RssFeedIcon,
} from "@mui/icons-material";

import { version } from "../../../../package.json";

const MobileContent = observer(
  ({
    triggers,
    userFeedUrl,
    trackingId,
    displayName,
    logOut,
    mobileMode,
    updateAddUrl,
    addUrl,
    addApp,
    addForce,
    selectionText,
    pendingSearch,
    updatePendingSearch,
    search,
    updateSearch,
    daysAgo,
    daysAgoOptions,
    updateDaysAgo,
    changePlaylistMode,
  }) => {
    const adjustedDaysAgoOptions = [
      ...new Set([...daysAgoOptions, daysAgo]),
    ].sort((a, b) => a - b);

    // Handle search input changes - update both pending and actual search
    const handleSearchChange = (value) => {
      updatePendingSearch(value);
      // Update search immediately to filter feeds in real-time
      updateSearch(value);
    };

    // Handle reset button click
    const handleResetClick = () => {
      updatePendingSearch("");
      updateSearch("");
    };

    if (mobileMode === "addArticle") {
      return (
        <AddArticle
          {...{
            triggers,
            trackingId,
            updateAddUrl,
            addUrl,
            addApp,
            addForce,
            selectionText,
          }}
        />
      );
    }

    if (mobileMode === "discover") {
      return (
        <div className="discover-mobile-top-bar">
          <div className="search-container">
            <div className="search">
              <img src={Search} alt="Search" />
              <input
                type="text"
                placeholder="Search feeds..."
                value={pendingSearch}
                className="placeholder"
                onChange={({ target: { value } }) => handleSearchChange(value)}
              />
              {pendingSearch.trim().length > 0 ? (
                <img src={Reset} alt="Clear" onClick={handleResetClick} />
              ) : null}
            </div>
          </div>
        </div>
      );
    }

    if (mobileMode === "playlist") {
      return (
        <div className="days-ago">
          <select
            onChange={({ target: { value } }) => changePlaylistMode(value)}
          >
            <option key="all" value="all">
              Show All Articles
            </option>
            <option key="unplayed" value="unplayed">
              Show Unplayed Articles
            </option>
            <option key="played" value="played">
              Show Played Articles
            </option>
          </select>
        </div>
      );
    }

    if (mobileMode === "settings") {
      return (
        <div className="actions">
          {/* <a
            className="link"
            href="https://audiblogs.upvoty.com/"
            target="_blank"
          >
            <img src={Feature} />
            <span>Request a Feature</span>
          </a> */}
          {/* <a className="link" href="https://audioread.tolt.io/" target="_blank">
            <PaidIcon />
            <span>Earn 25% Commission</span>
          </a> */}
          {userFeedUrl && (
            <Link
              className="link"
              to={`/setupnew?feed_url=${encodeURIComponent(userFeedUrl)}`}
            >
              <RssFeedIcon />
              <span>Connect Podcast App</span>
            </Link>
          )}
          <Link className="link" to="/settings">
            <AccountCircleIcon />
            <span>Settings</span>
          </Link>
          <a className="link" onClick={logOut}>
            <PowerSettingsNewIcon />
            <span>Log Out</span>
          </a>

{/* 
          <div className="profile">
            <span>
              <img src={Profile} />

              <span>{displayName}</span>
            </span>
          </div> */}
          <button
            style={{
              backgroundColor: "transparent",
              border: "1px white solid",
              borderRadius: "5px",
              color: "white",
              fontSize: "14px",
              padding: "5px 10px",
              margin: "20px",
            }}
            onClick={(e) => {
              window.location.reload(true);
            }}
          >
            Click here to refresh
          </button>
          <div>v{version}</div>
        </div>
      );
    }

    return null;
  }
);

export default MobileContent;
